//轨迹图
export default {
    async initLayer(vm, planInfo, planId) {
        const MapView = vm.MapView;

        const result = {};
        const param = this.checkParameter(planInfo);
        if (param) {
            const {
                /* serviceType, */
                serviceUrl,
                serviceLayer,
                matchField,
                sortField,
                showField,
                valueField,
            } = param;
            const features = await this.getFeatures(
                vm,
                serviceUrl,
                serviceLayer,
                sortField
            );
            const bounds = this.getBounds(features);
            if (features[0].geometry.type === 'Point') {
                MapView.map.fitBounds(bounds);
                const _featureGroups = this.groupByField(features, matchField);
                const routes = [];
                _featureGroups.forEach(group => {
                    if (group.length > 1) {
                        const lnglats = [];
                        group.forEach(f => {
                            lnglats.push(f.geometry.coordinates);
                        });
                        routes.push({
                            planId: planId,
                            model: 'Roads',
                            coords: lnglats,
                            show: group[0].properties[showField],
                            key: valueField,
                            value: group[0].properties[valueField],
                            lineStyle: {
                                normal: {
                                    width: 4,
                                },
                            },
                        });
                    }
                });
                const series = {
                    planid: planId,
                    type: 'lines',
                    coordinateSystem: 'GLMap',
                    effect: {
                        show: true,
                        constantSpeed: 55,
                        color: 'rgb(200, 40, 0)',
                        symbolSize: 12,
                        trailWidth: 2,
                        trailLength: 0.1,
                        trailOpacity: 1,
                    },
                    polyline: true,
                    data: routes,
                };
                result.info = true;
                result.data = series;
                return result;
            } else if (features[0].geometry.type === 'LineString') {
                MapView.map.fitBounds(bounds);
                const routes = [];
                features.forEach(f => {
                    routes.push({
                        planId: planId,
                        coords: f.geometry.coordinates,
                        show: f.properties[showField],
                        key: valueField,
                        value: f.properties[valueField],
                        lineStyle: {
                            normal: {
                                width: 4,
                            },
                        },
                    });
                });
                const series = {
                    planid: planId,
                    type: 'lines',
                    coordinateSystem: 'GLMap',
                    effect: {
                        show: true,
                        constantSpeed: 55,
                        color: 'rgb(200, 40, 0)',
                        symbolSize: 12,
                        trailWidth: 2,
                        trailLength: 0.1,
                        trailOpacity: 1,
                    },
                    polyline: true,
                    data: routes,
                };
                result.info = true;
                result.data = series;
                return result;
            } else {
                result.info = false;
                return result;
            }
        } else {
            result.info = false;
            return result;
        }
    },
    //检查参数是否完整
    checkParameter(json) {
        try {
            const parameter = {};
            const thematic = json.configcont.thematic;
            parameter.serviceType = thematic.serviceType;
            parameter.serviceUrl = thematic.serviceUrl;
            parameter.serviceLayer = thematic.serviceLayer;
            parameter.matchField = thematic.matchField;
            parameter.sortField = thematic.sortField;
            parameter.showField = thematic.showField;
            parameter.valueField = thematic.valueField;
            for (const values of Object.values(parameter)) {
                if (values === undefined) {
                    return false;
                }
            }
            return parameter;
        } catch {
            return false;
        }
    },
    async getFeatures(vm, url, layerName, sortField) {
        const wfsQueryObj = new GeoGlobe.Query.WFSQuery(url, layerName, {
            geometryName: 'GEOMETRY',
            version: '1.0.0',
            maxFeatures: null,
            sortBy: [
                {
                    property: sortField,
                    order: 'ASC',
                },
            ],
        });
        return new Promise((resolve, reject) => {
            try {
                wfsQueryObj.query(
                    null,
                    ({ geojson }) => {
                        resolve(geojson.features);
                    },
                    reject
                );
            } catch (error) {
                vm.error('方案数据解析失败，请检查数据配置！');
                reject(error);
            }
        });
    },
    getBounds(features) {
        const len = features.length;
        const geometries = new Array(len);
        for (let i = 0; i < len; ++i) {
            geometries[i] = GeoGlobe.Feature.fromGeoJson(
                features[i]
            )[0].geometry;
        }
        const geom = new GeoGlobe.Geometry.Collection(geometries);
        geom.calculateBounds();
        return geom.bounds;
    },
    groupByField(data, field) {
        const fields = [];
        const _data = [];
        data.forEach(d => {
            const index = fields.findIndex(
                element => element === d.properties[field]
            );
            if (index === -1) {
                fields.push(d.properties[field]);
                _data.push([d]);
            } else {
                _data[index].push(d);
            }
        });
        return _data;
    },
};
